<template>
<div>
</div>
</template>

<script>
  import { mapMutations, mapActions } from 'vuex'

  export default {
    methods: {
      ...mapMutations([ 'SET_IFRAME' ]),
      ...mapActions([ 'showSnack '])
    },

    mounted() {
      this.SET_IFRAME(null)

      // Initiate the event handler in App.vue
      if ('payment_intent_client_secret' in this.$route.query) {
        window.top.postMessage({
          message: '3DS-authentication-complete',
          payload: this.$route.query.payment_intent_client_secret
        });
      } else {
        const { payment_type, order_id } = this.$route.query

        if (payment_type == 'GLOBAL_PAYMENTS' && order_id != null) {
          window.top.postMessage({
            message: '3DS-GLOBALPAYMENTS-authentication-complete',
            payload: order_id
          });
        }
      }
    }
  };
</script>
